import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { adm, apiErr } from "../../lib/adminApi";
import { PageHead, Btn, Badge, statusTone } from "../../components/admin/ui";

export default function AdminReleases() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { adm.list("releases").then(setItems).catch(() => {}); }, []);

  const create = async () => {
    const title = window.prompt("New release title:");
    if (!title) return;
    const slug = title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");
    try {
      const doc = await adm.create("releases", {
        title, slug, releaseType: "Single", dimension: null, artwork: "", cover: "",
        year: new Date().getFullYear(), status: "UPCOMING", description: "", statement: "",
        trackList: [], streamingLinks: {}, publicationStatus: "draft",
      });
      navigate(`/admin/releases/${doc.id}`);
    } catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div data-testid="admin-releases">
      <PageHead title="Releases & Tracks" sub="Albums, EPs and singles. Draft → Scheduled → Published → Archived.">
        <Btn onClick={create} testid="release-new">NEW RELEASE</Btn>
      </PageHead>
      {items.map((r) => (
        <Link key={r.id} to={`/admin/releases/${r.id}`} data-testid={`release-row-${r.id}`}
          className="flex items-center justify-between gap-4 border-t border-white/10 py-4 hover:bg-white/[0.03] px-2 transition-colors">
          <div className="flex items-center gap-4 min-w-0">
            {r.artwork && <img src={r.artwork} alt="" className="w-10 h-10 object-cover" />}
            <div className="min-w-0">
              <p className="text-white/90 truncate">{r.title}</p>
              <p className="font-mono text-[9px] text-white/40 mt-0.5">{r.releaseType?.toUpperCase()} · /{r.slug} · {r.trackList?.length || 0} TRACKS</p>
            </div>
          </div>
          <div className="flex items-center gap-2 shrink-0">
            {r.featured && <Badge tone="gold">FEATURED</Badge>}
            <Badge tone={statusTone(r.publicationStatus)}>{r.publicationStatus}</Badge>
          </div>
        </Link>
      ))}
    </div>
  );
}
